exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img {\n    border-radius: 5px;\n    max-width: 80%;\n}\n\n.flexCol {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    padding: 0 10px;\n    max-width: 100%;\n}\n\n.aocTop {\n    margin-top: 0.55rem;\n}\n\n.aocBottom {\n    margin-bottom: 0.65rem;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/masonpimentel/Repos/mason-blog/src/app/advent-of-code/advent-of-code.component.css
// module id = ../../../../../src/app/advent-of-code/advent-of-code.component.css
// module chunks = main